import { useState } from "react";
const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;
const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};

const initialStatebox = {
  ejercicioinicio: ejercicioActual,
  // periodoinicio: 1,
  ejerciciofin: ejercicioActual,
  periodoinicio: mesActual,
  periodofin: mesActual,
  periodo: 1,
  mesfin: mesActual,
  whatsapp: 'C',
  facturado: 'C',
  estatus: 'CC',
  motivo: 'CC',
  horasuso: 0,
  linea: 0,
  titulosucursal: "",
  titulodepartamento: "",
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
